var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPhoneBlueMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B8C3CC"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.142 6.989L5.482 0 1.65 2.406.225 5.866c-.356.864-.287 1.845.187 2.65l.581.989c3.034 5.158 8.344 10.467 13.502 13.501l.988.581c.806.475 1.787.544 2.651.188l3.46-1.425L24 18.517l-6.989-4.659-3.135 2.498-.412.292-.294-.197c-.994-.683-2.051-1.572-3.05-2.572l-.329-.335c-.866-.899-1.636-1.831-2.242-2.715l-.197-.293.333-.466 2.457-3.081z",
    transform: "translate(-693 -234) translate(460 226) translate(233 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneBlueMedium);
export default __webpack_public_path__ + "static/media/ic-phone-blue-medium.e9c0b547ca34a4151a9fdfe7b94e5d64.svg";
export { ForwardRef as ReactComponent };